import { IUpdateWebsitesDataDTO, WebsitesStatus } from '@/models/websites.model';
import { TWebsiteFormValues, WebsiteFieldsNames } from '../helpers';

export class UpdateWebsiteDTO implements IUpdateWebsitesDataDTO {
  id?: string;

  title: string;

  description: string;

  imageTitle?: string;

  position?: number;

  status?: WebsitesStatus;

  image?: string;

  constructor(values: TWebsiteFormValues, id?: string) {
    this.id = id;
    this.title = values[WebsiteFieldsNames.TITLE];
    this.description = values[WebsiteFieldsNames.DESCRIPTION];
    this.imageTitle = values[WebsiteFieldsNames.IMAGE_TITLE];
    if (values[WebsiteFieldsNames.POSITION]) {
      this.position = values[WebsiteFieldsNames.POSITION];
    }
    this.status = values[WebsiteFieldsNames.STATUS];
    if (typeof values[WebsiteFieldsNames.IMAGE] !== 'string') {
      this.image = values[WebsiteFieldsNames.IMAGE];
    }
  }
}
